import request from '@/utils/request'

const exchangeURL = {
  List: '/exchange/list',
  Detail: '/exchange/view',
  Create: '/exchange/create',
  Update: '/exchange/update',
  UpdateState: '/exchange/status-update'
}

// 兑换列表
export function getListExchange (data) {
  return request({
    url: exchangeURL.List,
    method: 'post',
    data
  })
}

// 兑换详情
export function detailExchange (data) {
  return request({
    url: exchangeURL.Detail,
    method: 'post',
    data
  })
}

// 兑换创建
export function createExchange (data) {
  return request({
    url: exchangeURL.Create,
    method: 'post',
    data
  })
}

// 兑换更新
export function updateExchange (data) {
  return request({
    url: exchangeURL.Update,
    method: 'post',
    data
  })
}

// 兑换状态更新
export function updateStateExchange (data) {
  return request({
    url: exchangeURL.UpdateState,
    method: 'post',
    data
  })
}

export default {
  detailExchange,
  createExchange,
  updateExchange,
  getListExchange,
  updateStateExchange
}
